import { Upload } from "lucide-react";
import { DataIntakePanel } from "@/components/control-tower/DataIntakePanel";
import { SectionPanel } from "@/components/ui/section-panel";
import { useBuildings } from "@/lib/api/useBuildings";

// Data-ingest ("Syötä dataa") lives in Konfiguraatio at building scope — it is data provisioning
// (CSV / Excel historical upload, AI analysis, equipment mapping), which belongs with the
// structure/sources/mapping setup here. Operator-gated by the caller.
export function ConfigDataIntakeSection({
  buildingId,
  onChanged,
}: {
  buildingId: string;
  onChanged?: () => void;
}) {
  const buildingsState = useBuildings();
  const building =
    buildingsState.status === "ok"
      ? (buildingsState.buildings.find((b) => b.id === buildingId) ?? null)
      : null;

  return (
    <SectionPanel
      icon={Upload}
      title="Syötä dataa"
      subtitle="Tuo mittausdataa talotekniikkaan (CSV) — kartoi signaalit ja tallenna historia; käyttöön otto Signaalit-välilehdellä"
    >
      <DataIntakePanel
        buildingId={buildingId}
        buildingName={building?.name ?? ""}
        onImported={onChanged}
      >
        <button
          type="button"
          className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          <Upload className="h-4 w-4" />
          Syötä dataa
        </button>
      </DataIntakePanel>
    </SectionPanel>
  );
}
